import styles from "./PageTitle.module.css";

type PageTitleProps = {
  title: string;
  subtitle: string;
};

function PageTitle({ title, subtitle }: PageTitleProps) {
  return (
    <div className={styles.title}>
      <h1>{title}</h1>
      <p>{subtitle}</p>
    </div>
  );
}
export default PageTitle;
